// extracted by mini-css-extract-plugin
export default {"container":"infoTable_container__fZshM","info__table":"infoTable_info__table__fPETO","title__content":"infoTable_title__content__9lui2"};